import { HtmlContentProperty } from '../../../interfaces/html-content-property';

// font weight simply gets the font weight from the styles
export const fontWeight: HtmlContentProperty = {
  name: 'fontWeight',
  value: 'fontWeight'
};
